
<template>
  <div class="full-width">
    <div>
      <h3 style="color:#444;border-bottom: 1px solid #444;">Video Scroller</h3>
      <input v-model="value.url" placeholder="Enter the video URL" />
      <input v-model="value.thumbnail" placeholder="Enter thumbnail URL" />
      <input v-model="value.videoLength" placeholder="Enter the length of the video" />
      <div v-for="(html, index) in value.items" :key="index">
        <froala :config="froalaConfig" v-model="value.items[index]" style="width:100%;margin:0;min-height: 100%;margin-top:10px;"></froala>
        <button style="margin: 0 auto;margin-top:10px;" @click="value.items.splice(index,1)">Remove Text Box</button>
      </div>
      <button style="margin: 0 auto;margin-top:10px;" @click="value.items.push('')">Add Text Box</button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import Froala from "./Froala";
require("firebase/firestore");

export default {
  components: { Froala },
  data: function() {
    return {
      froalaConfig: {
            imageDefaultWidth: 0,
            toggleModal: this.toggleModal,
            toolbarButtons: 	{
              'moreText': {
                'buttons': ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting']
              },
              'moreParagraph': {
                'buttons': ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote']
              },
              'moreRich': {
                'buttons': ['insertLink','insertImage', 'insertTable', 'emoticons',  'specialCharacters','insertHR'],
                'buttonsVisible': 3
              },
              'moreMisc': {
                'buttons': ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'],
                'align': 'right',
                'buttonsVisible': 2
              }
            },
          immediateVueModelUpdate: false,
          vueIgnoreAttrs: null
        }
    }
  },
  props:{
      value:{
          type: Object,
          required:true
      },
  },
  methods: {
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    changeImage: function() {
      this.$emit('changeImage', {
        callback: (images) => {
          this.value.image = images
        }
      })
    }
  }
  
}
</script>
<style>
.image-uploader {
  position:absolute;
  left:0;
  top:0;
  bottom:0;
  right:0;
  background-color: rgba(0,0,0,0.6);
  justify-content:center;
  align-items: center;
  display:none;
}
.image-parent:hover .image-uploader {
  display:flex;
}
</style>
<style scoped>
img {
  display:block;
  margin:5px auto;
  height: 400px;
  width: 657px;
  object-fit: cover;
}
.image-parent {
  position:relative;
}

.full-width {
  justify-content: center;
  width:100%;
  padding:20px;
  background: #eee;
  display:flex
}
input {
  display: block;
  width:657px;
  margin:5px auto;
}

</style>


// WEBPACK FOOTER //
// videoScroller.vue?7914b55c